import { Job } from 'sprockets_react/job_wizards/registries'

Job.seedData = function() {
    return {
        id:                  null,
        attachments:         [],
        backToSubmit:        false,
        budgetInMind:        'no',
        budgetPriceRange:    null,
        budgetSetPriceRange: null,
        budgetType:          null,
        canCall:             true,
        categories:          [],
        category:            "",
        category_id:         0,
        keyword:             null,
        cc_number:           null,
        contactPreference:   null,
        quoteEstimate:       null,
        description:         null,
        emailAddress:        "",
        extraDetails:        {},
        fileNames:           [],
        firstName:           null,
        maxBudget:           null,
        minBudget:           null,
        mustCreateAccount:   false,
        originName:          "ss",
        phoneNumber:         null,
        phoneVerificationRequired: false,
        preferedVisitTime:   null,
        price:               null,
        products:            { urgent: null },
        quoteType:           [],
        referrer:            {
                               url: location.href,
                               source: mobilecheck() ? 'mobile' : 'desktop',
                               user_agent: SS.appFn.userAgent(),
                               app_version: SS.appFn.urlInspector.getURLParameter('app_version') || 'modal',
                               channel: SS.appFn.urlInspector.getURLParameter('channel') || undefined,
                               cta: SS.appFn.urlInspector.getURLParameter('cta') || undefined
                             },
        exclusiveFor:        null,
        exclusiveBusiness:   null,
        requireVisit:        null,
        schedule:            "",
        scheduleDate:        null,
        scheduleTime:        null,
        siteVisit:           "",
        siteVisitTime:       null,
        suburb:              "",
        suburb_id:           0,
        with_cc:             null,
        omniAuthDetails:     { 'account_from_omni_auth': false },
        lastSlide:           false,
        fromPriceCalculator: false,
        additionalQuestion:  false,
        otp:                 null,
        closureSurvey:     {
            job: {},
            possibleBusinesses: [],
            outcome: null,
            providerAccountId: null,
            providerAccountName: null,
            rating: null,
            comments: null,
            selectedReasons: [],
            value: null
        },
        progressWidth:       null,
        choseMoreDetails:    false,
        preferredOutcome:    null,
        viewBusinessPhoneNumber: null,
        resetEmailAddressSlide: false
    }
}

Job.Data = Job.seedData()
